import { ReactNode } from "react";
import { View, Flex } from "@aws-amplify/ui-react";
import Navigation from "./NavigationLight";
import Footer from "./FooterModern";
// import SideBar from './sideBar/SideBar';
// import { useState } from 'react';

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  // const [iconsOnly, setIconsOnly] = useState(true);

  return (
    <Flex
      direction="column"
      minHeight="100vh"
      width="100%"
      backgroundColor="var(--amplify-colors-background-primary)"
    >
      <Navigation />
      <Flex direction="row" flex="1">
        {/* <SideBar iconsOnly={iconsOnly} setIconsOnly={setIconsOnly} /> */}
        <View
          flex="1"
          width="100%"
          backgroundColor="var(--amplify-colors-background-secondary)"
          padding={{ base: "0.5rem", medium: "1rem" }}
          // marginLeft={iconsOnly ? "3rem" : "10rem"}
          style={{ transition: "margin-left 0.3s ease" }}
        >
          {children}
        </View>
      </Flex>
      <Footer />
    </Flex>
  );
}

export default Layout;
